import { render, staticRenderFns } from "./LawMatterEvidenceForm.vue?vue&type=template&id=dfec70be&"
import script from "./LawMatterEvidenceForm.vue?vue&type=script&lang=js&"
export * from "./LawMatterEvidenceForm.vue?vue&type=script&lang=js&"
import style0 from "./LawMatterEvidenceForm.vue?vue&type=style&index=0&id=dfec70be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports